import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useHasScope} from "../../../../../config/globalConfig";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {setSnackbar} from "../../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../../util/state/globalVariables";
import {Button, Card, CardActions, CardContent, Grid} from "@mui/material";
import {useConfigurationRepository} from "../../../api/repositories/EnelXConfigurationRepository";
import ConfigurationInstances from "../sections/ConfigurationInstances";
import {ENELX_UPDATE_CONFIGURATION, SCOPE_FINANCE_REFUELLING_EDIT} from "../../../utils/FinanceScope";
import {useRecoilValue} from "recoil";
import {STATE_CONFIGURATION_FILTERS} from "../constants/EnelxRecoil";

const ConfigurationTable = () => {
    const { t } = useTranslation("finance", { keyPrefix: "enelx" });
    const hasScope = useHasScope;
    const { dispatchGlobalData } = useContext(GlobalContext);
    const { getConfiguration, updateConfiguration } = useConfigurationRepository();
    const [enableUpdate, setEnableUpdate] = useState<boolean>(false);
    const [data, setData] = useState<any[]>([]);
    const filterDefs = useRecoilValue(STATE_CONFIGURATION_FILTERS);
    function convertAmount(amount: any){
        return  Math.abs(amount) > 0 ? amount / 1000 : amount
    }

    useEffect(() => {
        reloadPage();
    }, [filterDefs]);

    function reloadPage(){
        getConfiguration(filterDefs).then((response: any) => {
            let data = response.content;
            let originData = [...data]
            originData.forEach((conf: any) => {
                conf["kwhPrice"] =  convertAmount(conf["kwhPrice"]).toFixed(3);
                conf["penaltyDurationPrice"] =  convertAmount(conf["penaltyDurationPrice"]).toFixed(3);
            })
            setData(originData.sort((a, b) => {
                if (a.useType === "PRIVATE" && b.useType !== "PRIVATE") {
                    return -1;
                } else if (a.useType !== "PRIVATE" && b.useType === "PRIVATE") { return 1; } else { return 0; }
            }));
        });
    }

    const saveData = () => {
        updateConfiguration( data!)
            .then((response) => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("tables.configuration.successUpdate"),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true,
                        },
                    },
                });
                reloadPage();
                setEnableUpdate(false)
            })
            .catch(() => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("tables.configuration.errorUpdate"),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        },
                    },
                });
            });
    };

    return (
        <>
            <Card variant="outlined">
                <CardContent>
                    <>
                        <Grid container columnSpacing={3}>
                            <Grid item xs={3}>
                                <p> {t("tables.configuration.useType")} </p>
                            </Grid>
                            <Grid item xs={3}>
                                <p> {t("tables.configuration.typeOfRecharge")} </p>
                            </Grid>
                            <Grid item xs={3}>
                                <p> {t("tables.configuration.kwhPrice")} </p>
                            </Grid>
                            <Grid item xs={3}>
                                <p> {t("tables.configuration.penaltyDurationPrice")} </p>
                            </Grid>
                        </Grid>
                        {data.map((row: any, index) =>
                            <ConfigurationInstances
                                row={row}
                                data={data}
                                index={index}
                                setData={setData}
                                setEnableUpdate={setEnableUpdate}
                            />
                        )}
                        <Grid item xs={3}>  </Grid>
                    </>
                </CardContent>
                <CardActions sx={{ justifyContent: "flex-end" }}>
                    <Button
                        onClick={saveData}
                        disabled={ !hasScope(ENELX_UPDATE_CONFIGURATION) || !enableUpdate}
                        size="small"
                    >
                        {t("tables.configuration.update")}
                    </Button>
                </CardActions>
            </Card>
        </>
    );
}

export default ConfigurationTable;
